export interface ParsedStatisticsXml {
	Statistics: {
		children?: StatsConfig
	};
}
export interface StatsConfig {
	events?: StatsEvent[];
	pages?: StatsPage[];
	servers?: ServersConfig[];
}

export interface StatsEvent {
	children?: {
		Event?: {
			attrs: {
				name: string;
			};
		}[];
	};
}

export interface StatsPage {
	children?: {
		Page?: {
			attrs: {
				name: string;
			};
		}[];
	};
}

export interface ServersConfig {
	children?: {
		GoogleAnalytics?: AnalyticsConfigNode[];
		GoogleTag?: GoogleTagConfigNode[];
		Piwik?: PiwikConfigNode[];
		Matomo?: MatomoConfigNode[];
		WebTrends?: WebTrendsConfigNode[];
		Xiti?: XitiConfigNode[];
		Piano?: PianoConfigNode[];
	};
}

export interface AnalyticsConfigNode {
	attrs: AnalyticsConfig;
}

export interface AnalyticsConfig {
	account?: string;
	name?: string;
	label?: string;
	session?: string;
	anonymize?: string;
	dimension1?: string;
	dimension2?: string;
	dimension3?: string;
	dimension4?: string;
	dimension5?: string;
	dimension6?: string;
	dimension7?: string;
	dimension8?: string;
	dimension9?: string;
}

export interface GoogleTagConfigNode {
	attrs: GoogleTagConfig;
}

export interface GoogleTagConfig {
	account?: string;
	anonymize?: string;
}

export interface PiwikConfigNode {
	attrs: PiwikConfig;
}

export interface PiwikConfig {
	id?: string;
	url?: string;
}

export interface WebTrendsConfigNode {
	attrs: WebTrendsConfig;
}

export interface WebTrendsConfig {
	id?: string;
	url?: string;
}

export interface XitiConfigNode {
	attrs: XitiConfig;
}

export interface XitiConfig {
	url?: string;
}

export interface PianoConfigNode {
	attrs: PianoConfig;
}

export interface PianoConfig {
	collectDomain?: string;
	id?: string;
}

export interface MatomoConfigNode {
	attrs: MatomoConfig;
}

export interface MatomoConfig {
	id?: string;
	scriptUrl?: string;
	trackerUrl?: string;
}

export interface Tracker {
	trackPage: (page: string, url: string, title: string) => void;
	trackEvent: (category: string, action: string, label: string, value?: number) => void;
	trackProperty: (name: string, value: string) => void;
	isLoaded: () => boolean;
}

// intern
export interface ResourceCredentials {
	login: string;
	password: string;
}

export enum TrackingType {
	Page = 'Page',
	Event = 'Event',
	Property = 'Property',
}

export interface TrackingPage {
	type: TrackingType.Page;
	arguments: TrackingPageArguments;
}

export interface TrackingEvent {
	type: TrackingType.Event;
	arguments: TrackingEventArguments;
}

export interface TrackingProperty {
	type: TrackingType.Property;
	arguments: TrackingPropertyArguments;
}

export interface TrackingPageArguments {
	page: string;
	url: string;
	title: string;
}

export interface TrackingEventArguments {
	category: string;
	action: string;
	label: string;
	value?: number;
}

export interface TrackingPropertyArguments {
	name: string;
	value: string;
}

export type TrackingData = TrackingPage | TrackingEvent | TrackingProperty;
export type TrackingArguments = TrackingPageArguments | TrackingEventArguments;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/statistics/typings.ts